import React = require("react");
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import LinearProgress from "material-ui/LinearProgress";
import diyLightTheme = require("diy/material-ui/diyLightTheme");

import * as Dispatcher from "./ProgressDialogDispatcher";
import {Status} from "./ProgressStatus";
import {Layout} from "./ProgressTask";

import l10n = require("diy/util/l10n");

interface ProgressDialogProps extends React.Props<ProgressDialog> {
    open: boolean;
    tasks?: any;
    title?: string;
    description?: string;
    image?: string;
    imageHeight?: number;
    layout?: Layout;
}

interface ProgressDialogState {
    open: boolean;
    failed: boolean;
}

export default class ProgressDialog extends React.Component<ProgressDialogProps, ProgressDialogState> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    constructor(props: any) {
        super(props);

        Dispatcher.register("dialogErrorWatcher", this.showError);

        this.state = {
            open: this.props.open,
            failed: false
        };
    }

    /**
     * Theme customization for the component
     */
    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    /**
     * Get called BEFORE the component will be removed from the DOM
     */
    componentWillUnmount() {
        this.closeDialog();
    }

    /**
     * Displays the error message with a close button if on of the tasks get the status failed
     */
    showError = (payload: any) => {
        if (payload.state === Status.FAILED) {
            this.setState({
                open: true,
                failed: true
            });
        }
    };

    /**
     * Returns the description message for display with unescaped html
     *
     * @returns {{__html: string}}
     */
    getDescription(): any {
        return {
            __html: this.props.description
        };
    }

    /**
     * Returns the error message for display with unescaped html
     *
     * @returns {{__html: string}}
     */
    getErrorMessage(): any {
        return {
            __html: l10n.getString("webComponentPageCreation.progress.error.apologise")
        };
    }

    /**
     * Closes the dialog
     */
    closeDialog: () => void = () => {
        this.setState({
            open: false,
            failed: false
        });
    };

    /**
     * Returns the component view
     *
     * @returns {any}
     */
    render() {
        let paddingTop = this.props.imageHeight ? this.props.imageHeight + "px" : "40px";
        let backgroundImage = this.props.image ? "url('" + this.props.image + "')" : 'none';

        let style = {
            zIndex: diy.editor.getNewTopZIndex()
        };
        let dialogStyle = {
            padding: 0
        };
        let bodyStyle = {
            padding: paddingTop + " 40px 30px 40px",
            backgroundImage: backgroundImage,
        };

        let linearProgress: JSX.Element;
        if (this.props.layout !== Layout.SPINNER) {
            linearProgress =
                <div className="dialog-linear-progress">
                    <LinearProgress mode="indeterminate" style={{backgroundColor: "#baddfa"}} />
                </div>;
        }

        return (
            <Dialog open={this.state.open}
                    bodyStyle={dialogStyle}
                    contentClassName="progress-dialog"
                    style={style}>

                <div className="dialog-body" style={bodyStyle}>
                    <h3 className="dialog-title">{this.props.title}</h3>

                    <div className="progress-tasks">
                        {this.props.tasks}
                    </div>
                </div>

                <div className="progress-bar" style={this.state.failed ? {display: 'none'} : {}}>
                    <div dangerouslySetInnerHTML={this.getDescription()}></div>
                    {linearProgress}
                </div>

                <div className="progress-error" style={this.state.failed ? {display: 'block'} : {}}>
                    <div className="dialog-actions-error"
                         dangerouslySetInnerHTML={this.getErrorMessage()}>
                    </div>

                    <div className="dialog-actions">
                        <FlatButton
                            onTouchTap={this.closeDialog}
                            label={l10n.getString("webComponentPageCreation.progress.error.closeButton")} />
                    </div>
                </div>
            </Dialog>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/progress-dialog/ProgressDialog.tsx
 **/